"use strict";
var _a, _b, _c, _d, _e;
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpdateContactDetailsDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const swagger_1 = require("@nestjs/swagger");
const update_child_details_dto_1 = require("./update-child-details.dto");
const class_transformer_1 = require("class-transformer");
class UpdateContactDetailsDto {
}
exports.UpdateContactDetailsDto = UpdateContactDetailsDto;
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "ID of the contact details", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsNumber)(),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDetailsDto.prototype, "id", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Contact ID associated with the contact details",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Contact ID must be a number." }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDetailsDto.prototype, "contact", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Gender of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Gender should be a number" }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDetailsDto.prototype, "gender", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Date of birth of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)({ message: "Date of birth should be a date" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], UpdateContactDetailsDto.prototype, "dateOfBirth", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Favorite food of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { message: "Favourite food must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDetailsDto.prototype, "favouriteFood", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Favorite restaurant of the contact",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, {
        message: "Favourite restaurant must not exceed 100 characters",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDetailsDto.prototype, "favouriteRestaurant", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Personal history of the contact",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(500, {
        message: "Personal history must not exceed 500 characters",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDetailsDto.prototype, "personalHistory", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Major achievements of the contact",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(500, {
        message: "Major achievements must not exceed 500 characters",
    }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDetailsDto.prototype, "majorAchievements", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Marital status of the contact",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Marital status should be a number" }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDetailsDto.prototype, "maritalStatus", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Date of wedding of the contact",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)({ message: "Date of wedding should be a date" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], UpdateContactDetailsDto.prototype, "dateOfWedding", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Spouse name of the contact", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { message: "Spouse name must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDetailsDto.prototype, "spouseName", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Spouse date of birth", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, class_validator_1.IsDate)({ message: "Spouse date of birth should be a date" }),
    tslib_1.__metadata("design:type", typeof (_c = typeof Date !== "undefined" && Date) === "function" ? _c : Object)
], UpdateContactDetailsDto.prototype, "spouseDateOfBirth", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Spouse working status", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)({ message: "Spouse working status should be a number" }),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDetailsDto.prototype, "spouseWorkingStatus", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Working company of the spouse",
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.MaxLength)(100, { message: "Working company must not exceed 100 characters" }),
    tslib_1.__metadata("design:type", String)
], UpdateContactDetailsDto.prototype, "workingCompany", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({
        description: "List of child details associated with the contact",
        type: [update_child_details_dto_1.UpdateChildDetailsDto],
        required: false,
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => update_child_details_dto_1.UpdateChildDetailsDto),
    tslib_1.__metadata("design:type", Array)
], UpdateContactDetailsDto.prototype, "childDetails", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Created by", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDetailsDto.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Updated by", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsInt)(),
    tslib_1.__metadata("design:type", Number)
], UpdateContactDetailsDto.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Created at", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    tslib_1.__metadata("design:type", typeof (_d = typeof Date !== "undefined" && Date) === "function" ? _d : Object)
], UpdateContactDetailsDto.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiProperty)({ description: "Updated at", required: false }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    tslib_1.__metadata("design:type", typeof (_e = typeof Date !== "undefined" && Date) === "function" ? _e : Object)
], UpdateContactDetailsDto.prototype, "updatedAt", void 0);
